import { ConfirmdeleteComponent } from './../../service/confirmdelete/confirmdelete.component';
// import { DialogService } from 'ng2-bootstrap-modal';
import { labels } from './../../service/sector.model';
import { ManageService } from './../../service/manage.service';
import { DBConnectorService } from './../../service/test.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { LoggedInGuard } from '../../authentication/logged-in.guard';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-labels',
  templateUrl: './labels.component.html',
  styleUrls: ['./labels.component.css']
})
export class LabelsComponent implements OnInit {
  bsModalRef: BsModalRef;
  public Label:any = {
    'SectorName': '',
    'LabelType': ''
  };

  SectorName: string;
  LabelType: string;
  LabelName: string;
  IsNull: boolean;

  labellist = [];
  result: any = {};
  sectorlist:any = [];
  showIsNull = true;

  constructor(private getlabels: DBConnectorService,
    private manage: ManageService,
    private _dialogService: BsModalService,
    private loggedInGuard: LoggedInGuard) {
  }

  getlabellist() {
    if (this.loggedInGuard.isSessionValid()) {
      this.getlabels.getalllabels()
        .subscribe(res => {
          this.labellist = res;
        });
    }
  }
  getsectorlist() {
    if (this.loggedInGuard.isSessionValid()) {
      this.getlabels.getsectors()
        .subscribe(res => this.sectorlist = res);
    }
  }

  LabelCreate() {
    if (this.loggedInGuard.isSessionValid()) {
      
      this.Label.SectorName = this.SectorName;
      this.Label.LabelType = this.LabelType;
      this.Label.LabelName = this.LabelName;
      this.Label.IsNull = this.IsNull;

      this.manage.createLabel(this.Label)
        .subscribe(
          (data) => {
            this.result = data;
            console.log(this.result);
            this.getlabellist();
          });
    }
  }

  showConfirm(lab: labels) {
    this.bsModalRef = this._dialogService.show(ConfirmdeleteComponent);
    this.bsModalRef.content.event.subscribe(isConfirmed => {
      if(isConfirmed) 
        this.LabelDelete(lab)
    })
    // const disposable = this.dialogService.addDialog(ConfirmdeleteComponent, {
    //   // title: 'Confirm title',
    //   // message: 'Confirm message'
    // }).subscribe((isConfirmed) => {
    //   // We get dialog result
    //   if (isConfirmed) {
    //     this.LabelDelete(lab);
    //   } else {
    //     // alert('declined');
    //   }
    // });
    // We can close dialog calling disposable.unsubscribe();
    // If dialog was not closed manually close it by timeout
    // setTimeout(() => {
    //   disposable.unsubscribe();
    // }, 10000);
  }

  LabelDelete(lab: labels) {
    if (this.loggedInGuard.isSessionValid()) {
      this.manage.deleteLabel(lab)
        .subscribe(
          (data) => {
            this.result = data;
            console.log(this.result);
            this.getlabellist();
          });
    }
  }

  ngOnInit() {
    if (this.loggedInGuard.isSessionValid()) {
      this.getsectorlist();
      this.getlabellist();
    }
  }

  onLabelTypeChange(selectedLabelType) {
    switch (selectedLabelType) {
      case 'Target':
      case 'Other': {
        this.showIsNull = false;
        break;
      }
      default: {
        this.showIsNull = true;
        break;
      }
    }
  }
}
